import { pmHistoryPluginKey } from '@atlaskit/editor-common/utils';
import { fg } from '@atlaskit/platform-feature-flags';
/**
 * @private
 * @deprecated
 * Do not use this directly. Delete when we cleanup `platform_editor_improve_history_state_performance`
 */
export var getPmHistoryPlugin = function getPmHistoryPlugin(state) {
  return state.plugins.find(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function (plugin) {
    return plugin.key === pmHistoryPluginKey;
  });
};

// Internal prosemirror history plugin does not export its plugin key.
// Previously we searched through all the plugins to find the history plugin
// but it's faster to look up the plugin directly via `getState`.
var fakePluginKey = {
  key: pmHistoryPluginKey,
  getState: function getState(state) {
    // The plugin key is used to index state
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return state[pmHistoryPluginKey];
  },
  get: function get(state) {
    return state.plugins.find(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (plugin) {
      return plugin.key === pmHistoryPluginKey;
    });
  }
};
export var getPmHistoryPluginState = function getPmHistoryPluginState(state) {
  if (fg('platform_editor_improve_history_state_performance')) {
    return fakePluginKey.getState(state);
  }
  var pmHistoryPlugin = getPmHistoryPlugin(state);
  if (!pmHistoryPlugin) {
    return;
  }
  return pmHistoryPlugin.getState(state);
};